import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { pageErrorState, pageState } from './recoil/state/page'
import { Loading, ToastContainer } from 'mailup-web-components'
import ErrorFeedback from 'Components/ErrorFeedback'
import { notifyParent } from 'mailup-react-helpers'
import BeePluginEditor from './components/BeePluginEditor'
import { editorState } from './recoil/state/editor'
import { getTotalTokensCountCallback } from './recoil/callbacks/callbacks'
import { ModalThirdParty } from './components/ModalThirdParty'

import Header from './components/Header'
import { ModalConfirmLeave } from './components/ModalConfirmLeave'
import { ModalSaveAndRename } from './components/ModalSaveAndRename'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'qs'

const SaveRowEdit = () => {
  const intl = useIntl()
  const location = useLocation()
  const history = useHistory()
  const { loading, backUrl } = useRecoilValue(pageState)
  const { error } = useRecoilValue(pageErrorState)
  const { idNewRow, dirty } = useRecoilValue(editorState)
  const getTotalTokensCount = useRecoilCallback(getTotalTokensCountCallback, [])
  const setPageState = useSetRecoilState(pageState)
  useEffect(() => {
    const backUrl = qs.parse(location.search, { ignoreQueryPrefix: true })
    setPageState(prev => ({ ...prev, backUrl: backUrl.backurl }))
    notifyParent('setFullScreen', [true])
    getTotalTokensCount()

    return () => {
      notifyParent('setFullScreen', [false])
    }
  }, [])

  useEffect(() => {
    if (idNewRow > 0) {
      const route = `/messages/email/save-row/${idNewRow}?backurl=${encodeURIComponent(
        backUrl
      )}`
      history.push(route)
    }
  }, [idNewRow])

  return (
    <>
      <Loading open={loading} />
      <ModalThirdParty />
      <ModalConfirmLeave />

      <ModalSaveAndRename />
      <ToastContainer />
      <Header />
      <div className='l-container'>
        <ErrorFeedback />
      </div>
      {!error && (
        <>
          <BeePluginEditor idNewRow={idNewRow} />
        </>
      )}
    </>
  )
}

export default SaveRowEdit
